import styled, { css } from "styled-components";

export const Container = styled.div`
  ${({ theme }) => css`
    max-width: ${theme.grid.smallContainer};
    margin: 0 auto;

    display: flex;
    flex-direction: column;
  `}
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-size: 1rem;
    font-weight: 500;
    color: ${theme.colors.dark_background};
    align-self: center;
    margin-top: 1rem;
    margin-bottom: 4rem;
  `}
`;

export const NextStepMessage = styled.h1`
  ${({ theme }) => css`
    font-size: 1rem;
    font-weight: 500;
    color: ${theme.colors.dark_background};
    align-self: center;
    margin-top: 3rem;
  `}
`;

export const WrapperForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-top: 3.6rem;
`;
